/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {AuthenticationConfig} from '../models/AuthenticationConfig';
import type {Error} from '../models/Error';
import type {ExternalLinksConfig} from '../models/ExternalLinksConfig';
import type {SentryConfig} from '../models/SentryConfig';
import type {ServerTimeZoneConfig} from '../models/ServerTimeZoneConfig';
import type {StatsigConfig} from '../models/StatsigConfig';
import type {StringJson} from '../models/StringJson';

export interface GetAuthenticationConfig$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getAuthenticationConfigRequest = createAction<PayloadData<void>>('CLIENT_CONFIG__GET_AUTHENTICATION_CONFIG__REQUEST');
export const getAuthenticationConfigSuccess = createAction<PayloadData<AuthenticationConfig>>('CLIENT_CONFIG__GET_AUTHENTICATION_CONFIG__SUCCESS');
export const getAuthenticationConfigFailure = createAction<PayloadData<Error, void, true>>('CLIENT_CONFIG__GET_AUTHENTICATION_CONFIG__FAILURE');

export const getAuthenticationConfigActions = [
    getAuthenticationConfigRequest,
    getAuthenticationConfigSuccess,
    getAuthenticationConfigFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getAuthenticationConfig = (config?: GetAuthenticationConfig$Config) => {
    return {
        CALL_API: {
            types: getAuthenticationConfigActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/authentication-config`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetCurrentEnvironment$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getCurrentEnvironmentRequest = createAction<PayloadData<void>>('CLIENT_CONFIG__GET_CURRENT_ENVIRONMENT__REQUEST');
export const getCurrentEnvironmentSuccess = createAction<PayloadData<StringJson>>('CLIENT_CONFIG__GET_CURRENT_ENVIRONMENT__SUCCESS');
export const getCurrentEnvironmentFailure = createAction<PayloadData<Error, void, true>>('CLIENT_CONFIG__GET_CURRENT_ENVIRONMENT__FAILURE');

export const getCurrentEnvironmentActions = [
    getCurrentEnvironmentRequest,
    getCurrentEnvironmentSuccess,
    getCurrentEnvironmentFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getCurrentEnvironment = (config?: GetCurrentEnvironment$Config) => {
    return {
        CALL_API: {
            types: getCurrentEnvironmentActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/environment`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetExternalLinksConfig$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getExternalLinksConfigRequest = createAction<PayloadData<void>>('CLIENT_CONFIG__GET_EXTERNAL_LINKS_CONFIG__REQUEST');
export const getExternalLinksConfigSuccess = createAction<PayloadData<ExternalLinksConfig>>('CLIENT_CONFIG__GET_EXTERNAL_LINKS_CONFIG__SUCCESS');
export const getExternalLinksConfigFailure = createAction<PayloadData<Error, void, true>>('CLIENT_CONFIG__GET_EXTERNAL_LINKS_CONFIG__FAILURE');

export const getExternalLinksConfigActions = [
    getExternalLinksConfigRequest,
    getExternalLinksConfigSuccess,
    getExternalLinksConfigFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getExternalLinksConfig = (config?: GetExternalLinksConfig$Config) => {
    return {
        CALL_API: {
            types: getExternalLinksConfigActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/external-links-config`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetSentryConfig$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getSentryConfigRequest = createAction<PayloadData<void>>('CLIENT_CONFIG__GET_SENTRY_CONFIG__REQUEST');
export const getSentryConfigSuccess = createAction<PayloadData<SentryConfig>>('CLIENT_CONFIG__GET_SENTRY_CONFIG__SUCCESS');
export const getSentryConfigFailure = createAction<PayloadData<Error, void, true>>('CLIENT_CONFIG__GET_SENTRY_CONFIG__FAILURE');

export const getSentryConfigActions = [
    getSentryConfigRequest,
    getSentryConfigSuccess,
    getSentryConfigFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getSentryConfig = (config?: GetSentryConfig$Config) => {
    return {
        CALL_API: {
            types: getSentryConfigActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/sentry-config`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetServerTimeZoneConfig$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getServerTimeZoneConfigRequest = createAction<PayloadData<void>>('CLIENT_CONFIG__GET_SERVER_TIME_ZONE_CONFIG__REQUEST');
export const getServerTimeZoneConfigSuccess = createAction<PayloadData<ServerTimeZoneConfig>>('CLIENT_CONFIG__GET_SERVER_TIME_ZONE_CONFIG__SUCCESS');
export const getServerTimeZoneConfigFailure = createAction<PayloadData<Error, void, true>>('CLIENT_CONFIG__GET_SERVER_TIME_ZONE_CONFIG__FAILURE');

export const getServerTimeZoneConfigActions = [
    getServerTimeZoneConfigRequest,
    getServerTimeZoneConfigSuccess,
    getServerTimeZoneConfigFailure
] as const;

/**
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getServerTimeZoneConfig = (config?: GetServerTimeZoneConfig$Config) => {
    return {
        CALL_API: {
            types: getServerTimeZoneConfigActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/server-timezone-config`,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        }
    }
};

export interface GetStatsigKey$Request {
    adminId: number;
}

export interface GetStatsigKey$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getStatsigKeyRequest = createAction<PayloadData<void, GetStatsigKey$Request>>('CLIENT_CONFIG__GET_STATSIG_KEY__REQUEST');
export const getStatsigKeySuccess = createAction<PayloadData<StatsigConfig, GetStatsigKey$Request>>('CLIENT_CONFIG__GET_STATSIG_KEY__SUCCESS');
export const getStatsigKeyFailure = createAction<PayloadData<Error, GetStatsigKey$Request, true>>('CLIENT_CONFIG__GET_STATSIG_KEY__FAILURE');

export const getStatsigKeyActions = [
    getStatsigKeyRequest,
    getStatsigKeySuccess,
    getStatsigKeyFailure
] as const;

/**
 * @param {number} meta.adminId
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getStatsigKey = (meta: GetStatsigKey$Request, config?: GetStatsigKey$Config) => {
    const TRANSPORT_GET_PARAMS = {
        adminId: meta.adminId,
    };
    return {
        CALL_API: {
            types: getStatsigKeyActions,
            method: ApiMethods.GET,
            endpoint: `/web-api/statsig-client-config`,
            TRANSPORT_GET_PARAMS,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

